import { mapGetters } from "vuex";

export const assessmentMixin = {
    computed: {
        ...mapGetters({
            settings: "settings"
        }),
        gradesList() {
            return this.settings.assessmentGradesList.filter((c) => c.used === true );
        },
        criteriaList() {
            if (this.settings.assessmentCriteriaList.length > 0) {
              return this.settings.assessmentCriteriaList.filter(
                (c) => c.used === true
              );
            }
          },
          gradeTitles() {
            let na = { score: 0, value: "n/a", name: "", color: "text-orange-800" };
            const grades = [...this.gradesList];
            grades.splice(0, 0, na);
            return grades;
          },

    },
    data() {
        return {

        };
    },
    methods: {
        gradeFromScore(score) {
            const rounded = score != undefined ? score.toFixed(0) : 0
            let grade = this.gradesList.filter((g) => {
              return parseInt(rounded) === g.score
            })
      
            return grade
          },
        setGradeColor(score, opacity) {
            let grade = this.gradeFromScore(score)

            if (grade.length > 0) {
                let rgb = this.hexToRgb(grade[0].color)
                let bg = "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + opacity +")"
                return 'background-color:' + bg + ';'
            } else {
                return 'background-color: #A0DBFA;'
            }
        },

        hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        checkforDeletion(assessment) {
            var total = 0
            this.criteriaList.forEach(function (c) {
                switch (c.key) {
                    case "criteria_1":
                      total += assessment.criteria_1
                      break;
                    case "criteria_2":
                        total += assessment.criteria_2
                        break;
                    case "criteria_3":
                        total += assessment.criteria_3
                      break;
                    case "criteria_4":
                        total += assessment.criteria_4
                      break;
                    case "criteria_5":
                        total += assessment.criteria_5 
                      break;
                  }
            });

            return total
        }
    },

}